module.exports = __webpack_public_path__ + "img/reju4.a40a2ab9.png";